import { jsx as _jsx } from "react/jsx-runtime";
import { I18nProvider } from "@i18n";
import { AppRouterProvider } from "@app/routes/router";
export const AppProviders = () => {
    // Compose global providers (Theme, I18n, Router, etc.)
    return (_jsx(I18nProvider, { children: _jsx(AppRouterProvider, {}) }));
};
